import { isPreviewWebHost } from 'components/common/previewEnv';
import { APP_DOMAIN } from 'services/constants';
import { buildWebUrl } from 'utils/webOrigin';

export default (url, subdomain) => {
  // Preview hosts only have TLS for pr-<N>.preview.ommnio.com (no company subdomains).
  const subDomain = !isPreviewWebHost(APP_DOMAIN) && subdomain ? subdomain : '';

  window.location.replace(buildWebUrl(url, subDomain));

  return null;
};
